<template>
    <div
        class="e-switch-wrapper tw:inline-flex tw:items-center tw:gap-2"
        :class="{ 'e-switch-wrapper--with-label': hasLabel }"
    >
        <ToggleSwitch
            v-bind="primeVueProps"
            :input-id="resolvedInputId"
            @update:modelValue="$emit('update:modelValue', $event)"
        />
        <label v-if="hasLabel" :for="resolvedInputId" class="e-switch-label tw:cursor-pointer">
            <slot />
        </label>
    </div>
</template>

<script>
import ToggleSwitch from 'primevue/toggleswitch';
import { getCurrentInstance } from 'vue';
/**
 * ESwitch - Abstraction wrapper around Primevue's ToggleSwitch
 */
export default {
    name: 'ESwitch',
    components: [ToggleSwitch],
    inheritAttrs: false,
    props: {
        inputId: {
            type: String,
            default: undefined,
        },
    },
    emits: ['update:modelValue'],
    computed: {
        hasLabel() {
            return Boolean(this.$slots.default);
        },
        primeVueProps() {
            return { ...this.$attrs };
        },
        resolvedInputId() {
            if (this.inputId != null && String(this.inputId).trim() !== '') {
                return String(this.inputId);
            }

            return `e-switch-${getCurrentInstance().uid}`;
        },
    },
};
</script>
